import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Quyết định nhân sự (danh sách). Mã nghiệp vụ và dữ liệu không dịch.
addMessages('vi', {
  'hrd.noWrite': 'Chưa mở ghi ở bản này',
  'hrd.allTypes': 'Tất cả loại',
  'hrd.tplHd': 'Mẫu văn bản & lịch hiệu lực',
  'hrd.tplCap': 'Mẫu văn bản quyết định',
  'hrd.manageTpl': 'Quản lý mẫu ở Hợp đồng lao động ›',
  'hrd.soon': 'Sắp hiệu lực · 30 ngày',
  'hrd.title': 'Quyết định nhân sự',
  'hrd.backHr': 'Về Nhân sự',
  'hrd.density': 'Mật độ',
  'hrd.dStd': 'Chuẩn',
  'hrd.dCompact': 'Gọn',
  'hrd.notif': 'Thông báo · 4 mới',
  'hrd.notifToast': '4 thông báo mới · mở ở Việc & Duyệt',
  'hrd.tplToast': 'Mẫu văn bản & lịch hiệu lực · chưa mở ở bản này',
  'hrd.more': 'Thêm thao tác',
  'hrd.create': 'Lập quyết định',
  'hrd.kNoWrite': '{k} · chưa mở ghi ở bản này',
  'hrd.emptyTitle': 'Chưa có quyết định nhân sự',
  'hrd.emptyDesc': 'Lập quyết định đầu tiên hoặc nạp bộ mẫu văn bản.',
  'hrd.retry': 'Thử lại',
  'hrd.createPlus': '+ Lập quyết định',
  'hrd.search': 'Tìm quyết định',
  'hrd.searchPh': 'Số QĐ, tên, UserName…',
  'hrd.filterType': 'Lọc theo loại quyết định',
  'hrd.count': '{n} / {m} quyết định',
  'hrd.ledger': 'Sổ quyết định',
  'hrd.noMatch': 'Không có quyết định khớp bộ lọc.',
});
addMessages('en', {
  'hrd.noWrite': 'Writing is not open in this version',
  'hrd.allTypes': 'All types',
  'hrd.tplHd': 'Templates & effective schedule',
  'hrd.tplCap': 'Decision templates',
  'hrd.manageTpl': 'Manage templates in Labor contracts ›',
  'hrd.soon': 'Taking effect · 30 days',
  'hrd.title': 'HR decisions',
  'hrd.backHr': 'Back to HR',
  'hrd.density': 'Density',
  'hrd.dStd': 'Standard',
  'hrd.dCompact': 'Compact',
  'hrd.notif': 'Notifications · 4 new',
  'hrd.notifToast': '4 new notifications · open in Tasks & Approvals',
  'hrd.tplToast': 'Templates & effective schedule · not open in this version',
  'hrd.more': 'More actions',
  'hrd.create': 'New decision',
  'hrd.kNoWrite': '{k} · writing is not open in this version',
  'hrd.emptyTitle': 'No HR decisions yet',
  'hrd.emptyDesc': 'Create the first decision or load the template set.',
  'hrd.retry': 'Retry',
  'hrd.createPlus': '+ New decision',
  'hrd.search': 'Search decisions',
  'hrd.searchPh': 'Decision no., name, UserName…',
  'hrd.filterType': 'Filter by decision type',
  'hrd.count': '{n} / {m} decisions',
  'hrd.ledger': 'Decision ledger',
  'hrd.noMatch': 'No decisions match the filter.',
});
